/*************************************************/
/* MODAL                                         */
/*************************************************/

export function modal($body, bodyLoadingClass) {
    let $modal,
        $modalDialog,
        $modalContent,
        $modalCloseButton,
        $playVideoTrigger,
        utils;

    const init = function () {
        $modal = $(".modal"),
            $modalDialog = $(".modal-dialog"),
            $modalContent = $(".modal-content"),
            $modalCloseButton = $(".modal-close"),
            $playVideoTrigger = $(".play-video");

        modalUtils();

        if ($playVideoTrigger.length > 0) {
            $playVideoTrigger.each(function () {
                const $this = $(this);


                $this.click(function (e) {
                    e.preventDefault();
                    let targetModalId = $this.data("target");
                    let videoId = $this.data("video-id");
                    //If video id is not set, it's probably a link from a RTE
                    if (videoId === undefined) {
                        videoId = $(this).find("a").attr("href");
                        if (videoId.indexOf("/") === 0 && videoId.length > 1) {
                            videoId = videoId.substr(1);
                        }
                        targetModalId = "#video-modal";
                    }
                    if (videoId && targetModalId) {
                        utils.Video.PlayVideoInModal(targetModalId, videoId);
                    } else {
                        console.error("Video not found");
                    }
                });
            });
        }

        $modalCloseButton.click(utils.Modal.CloseModal);

        //Close if background is clicked, but not if modalDialog is clicked
        $modal.click(utils.Modal.CloseModal);
        $modalDialog.click(function (e) {
            e.stopPropagation();
        });
    };

    function modalUtils() {
        if (!utils) {
            utils = {
            };
        }

        if ($modal.length > 0) {
            utils.Modal = {
                OpenModal(modalId, content) {
                    const _modal = $(modalId);
                    $body.addClass("noscroll");
                    _modal.addClass("modal--show");
                    _modal.find($modalContent).html(content);
                },
                CloseModal(clearContent = true) {
                    $modal.removeClass("modal--show");
                    if (clearContent = true) {
                        $modalContent.html("");
                    }
                    $body.removeClass("noscroll");
                }
            };
        }

        utils.Video = {
            PlayVideoInModal(modalId, videoId) {
                let playerId = "modalplayer";
                let player = document.createElement("div");
                player.id = playerId;
                utils.Modal.OpenModal(modalId, player);
                $body.addClass(bodyLoadingClass);
                var ytplayer = new YT.Player(playerId,
                    {
                        height: "100%",
                        width: "100%",
                        videoId: videoId,
                        events: {
                            "onReady": onPlayerReady,
                            "onStateChange": onPlayerStateChange
                        },
                        playerVars: {
                            showinfo: 0,
                            rel: 0
                        }
                    });

                function onPlayerReady(event) {
                    $body.removeClass(bodyLoadingClass);
                    event.target.playVideo();
                }

                function onPlayerStateChange(event) {
                    if (event.data === YT.PlayerState.ENDED) {
                        ytplayer.destroy();
                        utils.Modal.CloseModal();
                    }
                }
            }
        };
    }

    init();
}